import React, { useState } from "react"
import { Box, Typography, Tabs, Tab, Button } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import ProjectListTab from "./components/ProjectListTab"
import OnSiteChecksTab from "./components/OnSiteChecksTab"
import AnalyticsAndReportingTab from "./components/AnalyticsAndReporting"

export default function WorkforceManagement() {
  const [tab, setTab] = useState(0)

  const handleTabChange = (_, newValue) => {
    setTab(newValue)
  }

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        height: "100%",
        borderRadius: "6px",
        fontFamily: "Inter Tight",
        padding: "4vh 2vw",
      }}
    >
      {/* Header */}
      <Typography
        variant="h2"
        sx={{
          color: "#0D0D0E",
          fontFamily: "Inter Tight",
          fontSize: "24px",
          fontWeight: 500,
          marginBottom: "1vh",
        }}
      >
        Workforce Estimation
      </Typography>

      <Typography variant="body1" sx={{ color: "#667085", marginBottom: "3vh" }}>
        Manage workforce compliance, track on-site presence, and monitor project analytics.
      </Typography>

      {/* Tabs */}
      <Box
        sx={{
          backgroundColor: "#F5F7FA",
          borderRadius: "6px",
          width: "100%",
        }}
      >
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            width: "100%",
            "& .MuiTabs-flexContainer": {
              width: "100%",
              justifyContent: "space-between",
            },
            "& .MuiTab-root": {
              flex: 1,
              maxWidth: "none",
              textTransform: "none",
              fontWeight: 400,
              fontSize: "14px",
              color: "#475467",
              backgroundColor: "#F5F7FA",
              minHeight: "40px",
              borderRadius: 0,
              transition: "0.2s ease",
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              borderRadius: "6px",
              fontWeight: 500,
              color: "#101828",
              boxShadow: "0 0 0 1px #E4E7EC inset",
            },
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab label="Project List" />
          <Tab label="On-Site Checks" />
          <Tab label="Analytics & Reporting" />
        </Tabs>
      </Box>

      {/* Section header below tabs */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "3vh",
        }}
      >
      </Box>

      {/* Tab content placeholder */}
      <Box sx={{ marginTop: "3vh" }}>
        {tab === 0 && <ProjectListTab />}
        {tab === 1 && <OnSiteChecksTab />}
        {tab === 2 && <AnalyticsAndReportingTab />}
      </Box>
    </Box>
  )
}
